<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>
    <div id="main-container">
        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div class="content-header"> </div>
        <div class="page-content settings">
            <div class="no-absolute m-t30">

                <form [formGroup]="liabilityForm">
                    <div class="col-md-6">
                        <label>{{'Liability.Label.Liability' | translate}}<span class="required">*</span></label>
                        <select formControlName="LiabilityNameId">
                            <option value=""> Select Liability</option>
                            <option *ngFor="let item of liabilityType" value="{{item.Id}}">{{item.Name}}</option>
                        </select>
                        
                      
                    </div>
                   
                        <div class="col-md-6">
                            <label>{{'Liability.Label.Limit' | translate}}<span class="required">*</span></label>

                            <input type="text" maxlength="32" formControlName="LiabilityLimit">
                        </div>
                        <div class="col-md-6">
                            <label>{{'Liability.Label.RenewalDate' | translate}}<span class="required">*</span></label>

                            <input type="text" class="date todate" formControlName="RenewalDate">
                        </div>
                        <div class="col-md-6">
                            <label>{{'Liability.Label.InsuranceCompanyName' | translate}}<span
                                    class="required">*</span></label>

                            <input type="text" maxlength="256" formControlName="InsuranceCompanyName">
                        </div>
                        <div class="col-md-6">
                            <label>{{'Liability.Label.PolicyNumber' | translate}}<span
                                    class="required">*</span></label>

                            <input type="text" maxlength="32" formControlName="PolicyNumber">
                        </div>
                       
                        <div class="col-md-12" style="display: none;">
                            <label>{{'Liability.Label.Notes' | translate}}</label>
                                    <textarea type="text" appCharCount [showinitial]=true [limit]=500 maxlength="500"
                                    formControlName="Notes"></textarea>
                                <span id="char-count" class="char-count"></span>
                          
                        </div>
                        <div class="col-md-6">
                            <label _ngcontent-dow-c87=""></label>
                            <div id="dropZone" class="input-upload" (dragover)="drag()" (dragleave)="dragLeave()">
    
                                <span class="btn-upload">
                                    <!-- <input type="file"> -->
                                    <input type="file" #fileInput (change)="addFile()" multiple accept=".pdf,image/*">
                                    <strong>{{'Common.Add-File'|translate}}</strong>
                                    {{'Common.DropFile'|translate}}
    
                                </span>
                                <!-- or drop files here -->
                            </div>
                            <span style="color: red;margin-top: -10px;font-size: 12px;display: inline-block;">{{"Common.PdfandImage"|translate}}</span>
                        </div>
                        <div class="col-md-12" style="margin-top:10px;">
                            <div *ngIf="uploadedFileName;">
                                <div class="file-list" *ngFor="let item2 of attachementList; let i = index">
    
                                    <div class="file-item" [ngClass]="(uploadedFileName) ? ('div'+ i):''">
                                        {{ item2.FileName}} <a href="javascript:void(0)" (click)="removeUnsavedAttachent(i)"
                                            class="icon delete round"></a></div>
    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
    
                            <div class="upload-file-error text-left" style="clear:both">{{uploadedFileError}}</div>
                            <div *ngIf="liabilityAttachementList;">
                                <div class="file-list" *ngFor="let item1 of liabilityAttachementList;">
                                    <div class="file-item" [ngClass]="(item1.Id > 0) ? ('divAttachmentId'+ item1.Id):''">
                                        <a [routerLink]="['/viewattachment', item1.Id]">{{item1.FileName}}</a>
                                        <a href="javascript:void(0)" [attr.disabled]="true" (click)="deleteAttach(item1.Id)"
                                            class="icon delete round"></a>
                                    </div>
    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <span class="error-message" *ngIf="error"> {{error}}</span>

                            <div>
                                <input type="submit" id="login" (click)="AddLiability(liabilityForm.value)"
                                    [disabled]="!liabilityForm.valid" class="btn btn-main"
                                    value="{{'Common.Save' | translate}}" />
                            </div>
                        </div>
                    </form>
            </div>

        </div>
    </div>
</div>
<div class="modal fade" id="delete-attachment-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div class="modal-body">
                <h4 class="modal-title m-b20">{{'Common.Delete'|translate}} !</h4>
                <h5 class="modal-title m-b20">{{'Common.DeleteAttachmentMessage'|translate}}</h5>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary"
                        (click)="updateBenefitPlanAttachments()">{{'Common.Ok'|translate}}</button>
                    <button type="submit" class="btn btn-primary"
                        data-dismiss="modal">{{'Common.Cancel'|translate}}</button>


                </div>
            </div>
        </div>
    </div>
</div>